import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Dumbbell } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleGoogle = () => {
        const redirect = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
    };

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success(`Welcome back, ${u.name}`);
            navigate(u.onboarded ? "/dashboard" : "/onboarding");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background">
            <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
                <div className="relative hidden overflow-hidden lg:block">
                    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1770513649465-2c60c8039806?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)" }} />
                    <div className="absolute inset-0 bg-black/70" />
                    <div className="relative flex h-full flex-col justify-between p-10 text-white">
                        <Link to="/" className="flex items-center gap-2">
                            <Dumbbell className="h-6 w-6 text-accent-red" />
                            <span className="font-display text-2xl font-black uppercase">Hyper<span className="text-accent-red">gains</span></span>
                        </Link>
                        <div>
                            <div className="label-eyebrow mb-3 text-accent-red">Welcome back</div>
                            <p className="font-display text-4xl font-black uppercase leading-tight">Another heavy session.<br />Another rep banked.</p>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center p-8">
                    <div className="w-full max-w-md">
                        <h1 className="font-display text-3xl font-black uppercase">Sign in</h1>
                        <p className="mt-2 text-sm text-muted-foreground">Log your work. Progress the load.</p>

                        <button onClick={handleGoogle} data-testid="login-google" className="mt-6 w-full rounded-sm border border-border bg-card px-4 py-3 text-sm font-bold uppercase tracking-wider hover:bg-secondary">
                            Continue with Google
                        </button>
                        <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-widest text-muted-foreground">
                            <div className="h-px flex-1 bg-border" /> or email <div className="h-px flex-1 bg-border" />
                        </div>
                        <form onSubmit={submit} className="space-y-3" data-testid="login-form">
                            <div>
                                <label className="label-eyebrow">Email</label>
                                <input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-1 w-full rounded-sm border border-border bg-card px-3 py-2 text-sm focus:border-accent-red focus:outline-none" />
                            </div>
                            <div>
                                <div className="flex items-center justify-between">
                                    <label className="label-eyebrow">Password</label>
                                    <Link to="/forgot-password" data-testid="login-forgot-link" className="text-[10px] font-bold uppercase tracking-wider text-accent-red hover:underline">Forgot?</Link>
                                </div>
                                <input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-1 w-full rounded-sm border border-border bg-card px-3 py-2 text-sm focus:border-accent-red focus:outline-none" />
                            </div>
                            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-sm bg-accent-red px-4 py-3 text-sm font-bold uppercase tracking-wider text-white hover:bg-[color:var(--accent-hover)] disabled:opacity-60">
                                {loading ? "Signing in…" : "Sign in"}
                            </button>
                        </form>
                        <p className="mt-6 text-center text-sm text-muted-foreground">
                            New here? <Link to="/register" className="font-bold text-accent-red hover:underline" data-testid="login-register-link">Start your 7-day free trial</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
